const translations = {
    pt: {
        manageUsers: 'Gerenciar Usuários',
        failedToLoadUsers: 'Falha ao carregar usuários: ',
        roleUpdatedTo: 'Cargo atualizado para ',
        idPrefix: 'ID: ',
        failedToUpdateRole: 'Falha ao atualizar cargo: ',
        idColumn: 'ID',
        user: 'Usuário',
        name: 'Nome',
        currentRole: 'Cargo Atual',
        newRole: 'Novo Cargo',
        adminOnly: 'Apenas administradores podem acessar esta funcionalidade',
        filterByName: 'Filtrar por nome',
        filterByRole: 'Filtrar por cargo',
        allRoles: 'Todos os cargos',
        noResults: 'Nenhum usuário encontrado com os filtros atuais',
        fivePerPage: '5 por página',
        tenPerPage: '10 por página',
        twentyFivePerPage: '25 por página',
        fiftyPerPage: '50 por página',
        showing: 'Mostrando',
        to: 'a',
        of: 'de',
        users: 'usuários',
        failedToUpdateRoleConflict: "Não foi possível alterar o perfil do usuário. Verifique se ele possui algum livro ou capítulo vinculado a ele."

    },
    en: {
        manageUsers: 'Manage Users',
        failedToLoadUsers: 'Failed to load users: ',
        roleUpdatedTo: 'Role updated to ',
        idPrefix: 'ID: ',
        failedToUpdateRole: 'Failed to update role: ',
        idColumn: 'ID',
        user: 'User',
        name: 'Name',
        currentRole: 'Current Role',
        newRole: 'New Role',
        adminOnly: 'Only administrators can access this feature',
        filterByName: 'Filter by name',
        filterByRole: 'Filter by role',
        allRoles: 'All roles',
        noResults: 'No users found with current filters',
        fivePerPage: '5 per page',
        tenPerPage: '10 per page',
        twentyFivePerPage: '25 per page',
        fiftyPerPage: '50 per page',
        showing: 'Showing',
        to: 'to',
        of: 'of',
        users: 'users',
        failedToUpdateRoleConflict: "Could not change user's role. Please check if they have any books or chapters assigned to them."
    }
};

export default translations;